<div class="ticket-management-container p-2 overflow-x-hidden">
  <header class="bg-white border-b border-gray-100 px-6 py-4 mb-6">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-4">
        <div class="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-50 text-blue-600 shadow-sm border border-blue-100">
          <i class="fa-solid fa-chart-pie text-xl"></i>
        </div>
        <div>
          <h1 class="text-xl font-bold text-gray-900 tracking-tight">Ticket Management</h1>
          <p class="text-xs text-gray-500 font-medium uppercase tracking-wider">Overview & Analytics</p>
        </div>
      </div>
      
      <button class="text-gray-400 hover:text-blue-600 transition-colors">
         <i class="fa-solid fa-arrows-rotate"></i>
      </button>
    </div>
  </header>
  
  <div class="px-6 pb-4">
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <div 
        *ngFor="let card of statusCards; let i = index"
        (click)="onCardClick(card.label)"
        class="group relative overflow-hidden flex items-center justify-between p-4 bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md hover:border-blue-200 transition-all cursor-pointer active:scale-95"
      >
        <div 
          class="absolute left-0 top-0 h-full w-1" 
          [style.background-color]="card.borderColor">
        </div>
        
        <div class="flex flex-col gap-0.5">
          <span class="text-[11px] font-bold text-gray-400 uppercase tracking-tight">
            {{ card.label }}
          </span>
          <div class="flex items-baseline gap-2">
            <span class="text-2xl font-bold text-gray-800 tracking-tighter" [style.color]="card.iconColor">
              {{ card.count }}
            </span>
            <span class="text-[10px] font-medium text-green-500 bg-green-50 px-1 rounded">
              +3%
            </span>
          </div>
          <small class="text-[11px] text-gray-500 line-clamp-1 italic">
            {{ card.description }}
          </small>
        </div>
  
        <div 
          class="flex h-10 w-10 items-center justify-center rounded-full bg-gray-50 group-hover:bg-white transition-colors border border-gray-100 shadow-inner"
        >
          <i [class]="card.icon" class="text-lg" [ngStyle]="{'color': card.iconColor}"></i>
        </div>
      </div>
    </div>
  </div>
  <!-- Tickets List Section -->
  <div class="bg-white rounded-lg shadow-md p-6">
    <div class="flex items-center justify-between mb-6">
      <h2 class="text-xl font-semibold text-blue-600">Tickets List - Total</h2>
      <button
        pButton
        type="button"
        label="Add Ticket"
        icon="pi pi-plus"
        class="p-button-primary"
        (click)="onAddTicket()">
      </button>
    </div>
    <app-ticket-table
      [tickets]="tickets"
      [columns]="tableColumns"
      (viewEvent)="onViewTicket($event)"
      (viewStatusEvent)="onViewStatus($event)"
      (commentEvent)="onViewComments($event)"
      (editEvent)="onEditTicket($event)"
      (deleteEvent)="onDeleteTicket($event)"
      (statusChangeEvent)="onStatusChange($event)">
    </app-ticket-table>
  </div>

  <!-- Add/Edit Ticket Modal -->
  <app-add-edit-ticket-modal
    [visible]="showAddTicketModal"
    [ticket]="editingTicket"
    (close)="onModalClose()"
    (save)="onTicketSaved($event)">
  </app-add-edit-ticket-modal>

  <!-- Status History Modal -->
  <app-status-history-modal
    [visible]="showStatusHistoryModal"
    [ticket]="selectedTicket"
    (close)="onStatusHistoryModalClose()">
  </app-status-history-modal>

  <!-- Comment Modal -->
  <app-comment-modal
    [visible]="showCommentModal"
    [ticket]="selectedTicket"
    (close)="onCommentModalClose()"
    (commentAdded)="onCommentAdded($event)">
  </app-comment-modal>

  <!-- Toast Messages -->
  <!-- <p-toast></p-toast> -->
</div>

